package com.downdogapp.client

class JsServerImage(override val url: String) : ServerImage